<custom-table [config]="customTable" [rowExpansionTemplate]="tableRowexpansion" (emitterLazyLoad)="lazyloadRecords($event)">
</custom-table>
<ng-template #tableRowexpansion let-data>
  <app-tramite-historial-actividad [tramRegistroId]="data.id" class="app-card mx-auto border-1 border-top-none border-noround-top" [enableReasignar]="true"/>
</ng-template>

